import React, { useState } from 'react';
import { useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Card,Modal } from 'react-bootstrap';
import { MapContainer, TileLayer, FeatureGroup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import L from 'leaflet';
import './EarthquakeSettings.css';
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import { MapHomeControl, MapInfoControl } from "../../../../common/MapControls/MapControls";
const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;
//const backendUrl = process.env.REACT_APP_BACK_URL_L;

const EarthquakeSettings = () => {
    const formRef = useRef();
    const mapRef = useRef(null);
    const [enableSimulation, setEnableSimulation] = useState(true);
    const [enableAreaofRes, setAreaofRes] = useState(true);
    const [enableAreaofInterest, setAreaofInterest] = useState(true);
    const [enable200KmBuffer, set200KmBuffer] = useState(true);
    //const [enableEqHazardZone, setEqHazardZone] = useState(true);
    const [enableUnitSource, setUnitSource] = useState(true);
    const [enableIOCSeaLevel, setIOCSeaLevel] = useState(true);
    const [enableHeatmap, setHeatmap] = useState(false);
    const [enableFaultLine, setFaultLine] = useState(false);
    const [enableSlabStrike, setSlabStrike] = useState(false);
    const [enableSlabDip, setSlabDip] = useState(false);
    const [enableSlabDepth, setSlabDepth] = useState(false);
    const [numberOfEQ, setNumberOfEQ] = useState(100);
    const [basemap, setBasemap] = useState('SATELLITE');
    const [minMagnitude, setMinMagnitude] = useState(2.5);
    const [email, setEmail] = useState('saroj@rimes.int');

    const [aoiGeoJson, setAoiGeoJson] = useState(null);  // This holds the drawn polygon
    const [aoiValue, setAoiValue] = useState('');
    const [showMap, setShowMap] = useState(false);
    const featureGroupRef = useRef();

  
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${backendUrl}/Municipalities/save-eq-settings/`);
        if (!res.ok) throw new Error("Failed to load settings");
        const data = await res.json();

        setEnableSimulation(data.enable_simulation === 'True');
        setAreaofRes(data.enable_area_of_responsibility === 'True');
        setAreaofInterest(data.enable_area_of_interest === 'True');
        set200KmBuffer(data.enable_200km_buffer === 'True');
        setUnitSource(data.enable_unit_source === 'True');
        setIOCSeaLevel(data.enable_ioc_sea_level === 'True');
        setHeatmap(data.enable_heatmap === 'True');
        setFaultLine(data.enable_fault_line === 'True');
        setSlabStrike(data.enable_slab_strike === 'True');
        setSlabDip(data.enable_slab_dip === 'True');
        setSlabDepth(data.enable_slab_depth === 'True');
        setNumberOfEQ(parseInt(data.number_of_eq));
        setBasemap(data.basemap);
        setMinMagnitude(parseFloat(data.min_magnitude));
        setEmail(data.email);
        // Parse AOI safely
        const parsedAoi = typeof data.area_of_interest === 'string'
        ? JSON.parse(data.area_of_interest.replace(/'/g, '"'))
        : data.area_of_interest;

        setAoiGeoJson(parsedAoi);

        // if (parsedAoi?.geometry?.type === "Polygon" && parsedAoi?.geometry?.coordinates) {
        //     const coords = parsedAoi.geometry.coordinates[0].map(([lng, lat]) => [lat, lng]);
        //     setAoiValue(JSON.stringify(coords));
        // }
        if (parsedAoi?.geometry?.type === "Polygon") {
            const coords = parsedAoi.geometry.coordinates[0].map(([lng, lat]) => [lat, lng]);
            setAoiValue(JSON.stringify(coords));
            setAoiGeoJson(parsedAoi); // This ensures the map loads it
        }
      } catch (error) {
        console.error("Failed to fetch settings:", error);
      }
    };
  
    fetchSettings();
  }, []);
  
  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    const formData = {
      enable_simulation: enableSimulation,
      enable_area_of_responsibility: enableAreaofRes,
      enable_area_of_interest: enableAreaofInterest,
      enable_200km_buffer: enable200KmBuffer,
      //enable_eq_hazard_zone: enableEqHazardZone,
      enable_unit_source: enableUnitSource,
      enable_ioc_sea_level: enableIOCSeaLevel,
      enable_heatmap: enableHeatmap,
      enable_fault_line: enableFaultLine,
      enable_slab_strike: enableSlabStrike,
      enable_slab_dip: enableSlabDip,
      enable_slab_depth: enableSlabDepth,
      number_of_eq: numberOfEQ,
      basemap: basemap,
      min_magnitude: minMagnitude,
      email: email,
      area_of_interest: aoiGeoJson, // or aoiValue if you're sending coordinates string
    };
    console.log(formData);
    
    try {
        const res = await fetch(`${backendUrl}/Municipalities/save-eq-settings/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        });
        const data = await res.json();
        if (data.status === 'success') {
            alert('Settings saved!');
        } else {
            alert('Error saving settings: ' + data.message);
        }
    } catch (error) {
        console.error('Save failed:', error);
        alert('Error saving settings');
    }
  };

    useEffect(() => {
        if (showMap && aoiGeoJson && featureGroupRef.current && mapRef.current) {
            const featureGroup = featureGroupRef.current;
            const map = mapRef.current;

            featureGroup.clearLayers();

            const geoCoords = aoiGeoJson.geometry.coordinates[0];
            const latlngs = geoCoords.map(([lng, lat]) => [lat, lng]); // Swap to [lat, lng]

            const polygon = L.polygon(latlngs);
            featureGroup.addLayer(polygon);

            const bounds = polygon.getBounds();
            if (bounds.isValid()) {
            map.fitBounds(bounds);
            }
        }
    }, [showMap, aoiGeoJson]);
  
  
  
  return (
    <div className="earthquake-settings-wrapper">
        <Container className="my-4">
        {/* <h4 className="mb-4  text-start" >Earthquake Settings</h4> */}
            <Card className="mb-4 custom-settings-card">
                <Form ref={formRef} onSubmit={handleFormSubmit}>
                    <Card.Body>
                    <Card.Title className="mb-3  text-start">Earthquake Settings</Card.Title>
                    
                        <Form.Group as={Row} className="mb-3" controlId="formEnableSimulation">
                        <Form.Label column sm={4} className="text-start">Enable Simulation</Form.Label>
                        <Col sm={8}>
                            <Form.Check 
                            type="switch" 
                            className="text-start"
                            checked={enableSimulation} 
                            onChange={() => setEnableSimulation(!enableSimulation)} 
                            />
                        </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="formNumEQ">
                        <Form.Label column sm={4} className="text-start">Number of EQ to show</Form.Label>
                        <Col sm={8}>
                            <Form.Control 
                            type="number" 
                            value={numberOfEQ} 
                            onChange={(e) => setNumberOfEQ(e.target.value)} 
                            />
                        </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="formBasemap">
                        <Form.Label column sm={4} className="text-start">Basemap</Form.Label>
                        <Col sm={8}>
                            <Form.Select value={basemap} onChange={(e) => setBasemap(e.target.value)}>
                            <option value="SATELLITE">SATELLITE</option>
                            <option value="OSM">OPEN-STREET</option>
                            <option value="WHITE">WHITE</option>
                            <option value="BLACK">BLACK</option>
                            </Form.Select>
                        </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="formMinMagnitude">
                        <Form.Label column sm={4} className="text-start">Minimum Magnitude</Form.Label>
                        <Col sm={8}>
                            <Form.Control 
                            type="number" 
                            value={minMagnitude} 
                            onChange={(e) => setMinMagnitude(e.target.value)} 
                            />
                        </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="formEmail">
                        <Form.Label column sm={4} className="text-start">Email</Form.Label>
                        <Col sm={8}>
                            <Form.Control 
                            type="email" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)} 
                            />
                        </Col>
                        </Form.Group>
                    
                    </Card.Body>
                    <Card.Body>
                    <Card.Title className="mb-3  text-start">Boundaries</Card.Title>
                        <Form.Group as={Row} className="mb-3" controlId="formEnableAreaofRes">
                            <Form.Label column sm={4} className="text-start">Show Area of Responsibility</Form.Label>
                            <Col sm={8}>
                                <Form.Check 
                                type="switch" 
                                className="text-start"
                                checked={enableAreaofRes} 
                                onChange={() => setAreaofRes(!enableAreaofRes)} 
                                />
                            </Col>
                            <Form.Label column sm={4} className="text-start">Show Area of Interest</Form.Label>
                            <Col sm={8}>
                                <Form.Check 
                                type="switch" 
                                className="text-start"
                                checked={enableAreaofInterest} 
                                onChange={() => setAreaofInterest(!enableAreaofInterest)} 
                                />
                            </Col>
                            <Form.Group as={Row} className="mb-3" controlId="formAreaOfInterest">
                                <Form.Label column sm={4} className="text-start">Set Area of Interest</Form.Label>
                                <Col sm={6}>
                                    <Form.Control
                                    type="text"
                                    readOnly
                                    value={aoiValue} // This should be state
                                    placeholder="Draw on map to set AOI"
                                    />
                                </Col>
                                <Col sm={2}>
                                    <Button variant="secondary" onClick={() => setShowMap(true)}>
                                    Open Map
                                    </Button>
                                </Col>
                                </Form.Group>
                                <Modal show={showMap} onHide={() => setShowMap(false)} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>Select Area of Interest</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ height: '400px' }}>
                                        <MapContainer center={[-8.8742, 125.7275]} zoom={6} style={{ height: '100%', width: '100%' }} whenCreated={(mapInstance) => { mapRef.current = mapInstance; }}>
                                          <MapHomeControl />
                                          <MapInfoControl text="Configure earthquake monitoring locations by selecting points on the map." />
                                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                        <FeatureGroup ref={featureGroupRef}>
                                            <EditControl
                                            position="topright"
                                            draw={{
                                                polygon: true,
                                                rectangle: false,
                                                circle: false,
                                                marker: false,
                                                polyline: false,
                                                circlemarker: false
                                            }}
                                            edit={{ remove: true }}
                                            // onCreated={(e) => {
                                            //     const layer = e.layer;
                                            //     const geoJson = layer.toGeoJSON();
                                            //     setAoiGeoJson(geoJson);

                                            //     const coordinates = geoJson.geometry.coordinates[0].map(
                                            //     ([lng, lat]) => [lat, lng]
                                            //     );
                                            //     setAoiValue(JSON.stringify(coordinates));
                                            //     setShowMap(false);
                                            // }}
                                            onCreated={(e) => {
                                                const layer = e.layer;
                                                featureGroupRef.current.clearLayers(); // Clear existing AOI before adding new one
                                                featureGroupRef.current.addLayer(layer);
                                                const geoJson = layer.toGeoJSON();
                                                // setAoiGeoJson(geoJson);
                                                // const coordinates = geoJson.geometry.coordinates[0].map(([lng, lat]) => [lat, lng]);
                                                // setAoiValue(JSON.stringify(coordinates));
                                                if (geoJson.geometry.coordinates.length > 0) {
                                                    setAoiGeoJson(geoJson);
                                                    const coordinates = geoJson.geometry.coordinates[0].map(([lng, lat]) => [lat, lng]);
                                                    setAoiValue(JSON.stringify(coordinates));
                                                }
                                                setShowMap(false);
                                              }}
                                              
                                            onEdited={(e) => {
                                                const layer = e.layers.getLayers()[0];
                                                const geoJson = layer.toGeoJSON();
                                                setAoiGeoJson(geoJson);

                                                const coordinates = geoJson.geometry.coordinates[0].map(
                                                ([lng, lat]) => [lat, lng]
                                                );
                                                setAoiValue(JSON.stringify(coordinates));
                                            }}
                                            />
                                        </FeatureGroup>
                                        </MapContainer>
                                    </Modal.Body>
                                </Modal>

                            <Form.Label column sm={4} className="text-start">Show 200km inland buffer</Form.Label>
                            <Col sm={8}>
                                <Form.Check 
                                type="switch" 
                                className="text-start"
                                checked={enable200KmBuffer} 
                                onChange={() => set200KmBuffer(!enable200KmBuffer)} 
                                />
                            </Col>
                            {/* <Form.Label column sm={4} className="text-start">Show EQ Hazard Zone</Form.Label>
                            <Col sm={8}>
                                <Form.Check 
                                type="switch" 
                                className="text-start"
                                checked={enableEqHazardZone} 
                                onChange={() => setEqHazardZone(!enableEqHazardZone)} 
                                />
                            </Col> */}
                        </Form.Group>
                    </Card.Body>
                    <Card.Body>
                        <Card.Title className="mb-3  text-start">Layers</Card.Title>
                        <Form.Group as={Row} className="mb-3" controlId="formenableUnitSource">
                        <Form.Label column sm={4} className="text-start">Show Unit Sources</Form.Label>
                        <Col sm={8}>
                            <Form.Check 
                            type="switch" 
                            className="text-start"
                            checked={enableUnitSource} 
                            onChange={() => setUnitSource(!enableUnitSource)} 
                            />
                        </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="formenableIOCSeaLevel">
                        <Form.Label column sm={4} className="text-start">Show IOC Sea Level</Form.Label>
                        <Col sm={8}>
                            <Form.Check 
                            type="switch" 
                            className="text-start"
                            checked={enableIOCSeaLevel} 
                            onChange={() => setIOCSeaLevel(!enableIOCSeaLevel)} 
                            />
                        </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="formenableHeatmap">
                        <Form.Label column sm={4} className="text-start">Show Heatmap</Form.Label>
                        <Col sm={8}>
                            <Form.Check 
                            type="switch" 
                            className="text-start"
                            checked={enableHeatmap} 
                            onChange={() => setHeatmap(!enableHeatmap)} 
                            />
                        </Col>
                        </Form.Group>
                    </Card.Body>

                    <Card.Body>
                    <Card.Title className="mb-3  text-start">Tectonic Plates/Slab                </Card.Title>
                    
                        <Form.Group as={Row} className="mb-3" controlId="formenableFaultLine">
                            <Form.Label column sm={4} className="text-start">Show Fault Lines / Tectonic Plate</Form.Label>
                            <Col sm={8}>
                                <Form.Check 
                                type="switch" 
                                className="text-start"
                                checked={enableFaultLine} 
                                onChange={() => setFaultLine(!enableFaultLine)} 
                                />
                            </Col>
                        </Form.Group>
                        
                        <Form.Group as={Row} className="mb-3" controlId="formenableSlabStrike">
                            <Form.Label column sm={4} className="text-start">Slab Strike</Form.Label>
                            <Col sm={8}>
                                <Form.Check 
                                type="switch" 
                                className="text-start"
                                checked={enableSlabStrike} 
                                onChange={() => setSlabStrike(!enableSlabStrike)} 
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="formenableSlabDip">
                            <Form.Label column sm={4} className="text-start">Slab Dip</Form.Label>
                            <Col sm={8}>
                                <Form.Check 
                                type="switch" 
                                className="text-start"
                                checked={enableSlabDip} 
                                onChange={() => setSlabDip(!enableSlabDip)} 
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="formenableSlabDepth">
                            <Form.Label column sm={4} className="text-start">Slab Depth</Form.Label>
                            <Col sm={8}>
                                <Form.Check 
                                type="switch" 
                                className="text-start"
                                checked={enableSlabDepth} 
                                onChange={() => setSlabDepth(!enableSlabDepth)} 
                                />
                            </Col>
                        </Form.Group>
                    </Card.Body>
                    <Card.Footer className="text-end">
                        <Button variant="primary" type="submit">
                            Save Settings
                        </Button>
                    </Card.Footer>

                </Form>
            </Card>
        </Container>
    </div>
  );
};

export default EarthquakeSettings;
